"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583",
    cx: "7.9813662",
    cy: "11.668264",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583-5",
    cx: "16.091457",
    cy: "11.69252",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 10.574156,8.4121905 3.532238,2.0393385",
    id: "path3615"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 10.014611,10.391961 3.990903,2.383337",
    id: "path3615-3-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 9.7371024,12.503937 3.8762366,2.230449",
    id: "path3615-3-5-4-2"
  })]
}));